import { makeStyles } from "@material-ui/core/styles";

export const ModalPromptStyles = makeStyles(() => ({
  confirmModalTitle: {
    color: "#043a50",
  },
  confirmModalContent: {
    color: "#043a50",
  },
}));
